import { Box, Button, FormControl, MenuItem, Select, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router';
import Container from 'src/components/container/Container';
import { useSettingsContext } from 'src/components/settings';
import useColumn from './hooks/useColumn';
import CustomTable from 'src/components/CustomTable';
import getEntries from 'src/services/clear-entry/getEntries';
import { useAuthContext } from 'src/auth/useAuthContext';
import usePagination from 'src/hooks/usePagination';
import Pagination from 'src/components/pagination';
import NoData from 'src/components/no-data/NoData';
import Logo from '../../assets/images/no-data/no_campaign_dash.svg'
export default function ClearEntryPage() {
    const { themeStretch } = useSettingsContext();
    const navigate = useNavigate()
    const { columns } = useColumn()
    const [entries, setEntries] = useState([])
    const { page, setPage, page_size, total_records, setTotal_records, totalPages, setTotalPages, handlePageSize } = usePagination()
    const [loading, setLoading] = useState(true)
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true)
            const response = await getEntries(page, page_size)
            setEntries(response._payload || []);
            setTotal_records(response?.total_records);
            setTotalPages(response?.totalPages);
            setLoading(false)
        }
        fetchData()
    }, [page, page_size])
    return (
        <div>
            <Container maxWidth={themeStretch ? false : 'lg'}>
                <Stack
                    direction="row"
                    sx={{ justifyContent: 'space-between', mb: 2 }}
                    alignContent="center"
                >
                    <Typography variant="h4" >
                        Entry Reset
                    </Typography>
                    <Button variant="contained" onClick={() => navigate('handle')}>
                        Create Entry Reset
                    </Button>
                </Stack>
                {(!entries?.length && !loading) && <NoData helperText="No data found.." src={Logo} />}
                {(entries?.length > 0 || loading) && <CustomTable
                    rows={entries}
                    columns={columns}
                    loading={loading}
                />}
                {entries?.length > 0 && <Stack
                    direction="row"
                    sx={{ width: '100%', p: { xs: 0, sm: 3 } }}
                    alignItems="center"
                    flexWrap="wrap"
                    justifyContent="space-between"
                    gap={1}
                >
                    <Box
                        minWidth={220}
                        width={{ xs: '100%', sm: 'max-content' }}
                        alignSelf={{ xs: 'center', sm: 'auto' }}
                    >
                        <Typography
                            sx={{ textAlign: { xs: 'center', sm: 'normal' } }}
                            color="primary"
                            variant="body1"
                        >

                            {`Showing ${page !== 0 ? page * page_size : 1}  to ${(page + 1) * page_size > total_records ? total_records : (page + 1) * page_size
                                } of ${total_records} entries`}


                        </Typography>
                    </Box>
                    <Box sx={{ order: { xs: 2, sm: 0 } }} flex={{ xs: 0, sm: 1 }}>
                        <FormControl sx={{ maxWidth: 'max-content', flexGrow: 1 }} fullWidth>
                            <Select
                                className="custom-select"
                                sx={{
                                    '&.MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-formControl.custom-select':
                                    {
                                        height: '37px',
                                    },
                                }}
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={page_size}
                                onChange={handlePageSize}
                                color="primary"
                                renderValue={() => `${page_size} per page`}
                            >
                                <MenuItem value={15}>15</MenuItem>
                                <MenuItem value={25}>25</MenuItem>
                                <MenuItem value={50}>50</MenuItem>
                                <MenuItem value={75}>75</MenuItem>
                                <MenuItem value={100}>100</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>

                    <Pagination page={page} setPage={setPage} totalPages={totalPages} />
                </Stack>}
            </Container>
        </div>
    )
}
